// @ts-nocheck
import { Button, Checkbox, Loader, Textarea } from "@mantine/core";
import { FaEnvelope, FaEye, FaPaperPlane, FaIndustry } from "react-icons/fa";
import { useRequest } from "ahooks";
import { Storage } from "aws-amplify";
import { useHistory } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { checkOrder, updateOrderApi, logout } from "../../api";
import { CheckGreenIcon } from "../../assets/svgs";
import { useUser } from "../../contexts";
import useHandleS3, { isPDF } from "../../hooks/useHandleS3";
import useOrderPosition from "../../hooks/useOrderPosition";
import QuantityModal from "./QuantityModal";
import {
  ApprovalStatus,
  ImageFile,
  Position,
  PositionImage,
  StatusConst,
  UploadStatus,
  UserOrder,
} from "../../interfaces";
import AccountLayout from "../../layouts/AccountLayout";
import {
  getCleanFileName,
  getExtensionFileName,
  isEditableCustomerView,
} from "../../utils";
import OrderAddressCard from "../account/OrderAddressCard";
import DangerModal from "../dialogs/DangerModal";
import AddImageCard from "./AddImageCard";
import CustomerOrderDataCard from "./CustomerOrderDataCard";
import UploadInstructions from "./UploadInstructions";
import Modal from "../modal/Modal";
import RenderApproveView from "../dashboard/RenderApproveView";
import RenderDontApproveView from "../dashboard/RenderDontApproveView";
import LoaderOverlay from "../loader/LoaderOverlay";
import useOrder from "../../hooks/useOrder";
import useSubscriber from "../../hooks/useSubscriber";
// @ts-expect-error type exists
import { onUpdateOrderItem } from "../../graphql/subscriptions";

export type UploadFileProps = {
  progress?: number;
  uploadStatus?: UploadStatus;
  file: File;
  positionImage?: PositionImage;
  positionIndex?: number;
  key: string;
};

export type TPositionReq = {
  position: number;
  quantity: number;
  atLeastFilledByOneFile: boolean;
};

const AccountBulkUpload: React.FC = () => {
  const [ShowQuantityModal, setShowQuantityModal] =
    React.useState<boolean>(false);
  const [{ order }, dispatchUser] = useUser();
  const { handleOrderUpdate } = useOrder();
  const [approved, setApproved] = useState<boolean>(false);
  const { data: updatedOrder } = useSubscriber(onUpdateOrderItem);
  const [furtherInfoFlowingMotifs, setFurtherInfoFlowingMotifs] =
    useState<boolean>(false);
  const [furtherInfoQualityCheck, setFurtherInfoQualityCheck] =
    useState<boolean>(false);
  const [sent, setSent] = useState<boolean>(false);
  const [files, setFiles] = useState<UploadFileProps[]>([]);
  const [deliveryNoteLoading, setDeliveryNoteLoading] =
    useState<boolean>(false);
  const [furtherInfo, setFurtherInfo] = useState<string>();
  const [positionRequirement, setPositionRequirement] = useState<
    TPositionReq[]
  >([]);
  const [uploading, setUploading] = React.useState<boolean>(false);
  const [totalQuantity, setTotalQuantity] = useState<number>(0);
  const { t } = useTranslation();
  const [uploadFiles, setUploadFiles] = React.useState<UploadFileProps[]>([]);
  const { positionImageAvailable } = useOrderPosition();
  const [current, setCurrent] = React.useState<PositionImage | null>(null);
  const completedImages = useRef<UploadFileProps[]>(new Array());
  const completedNotes = useRef<UploadFileProps[]>(new Array());
  const dataToBeUpdated = useRef<UserOrder>();
  const [cardLoading, setCardLoading] = React.useState(false);
  const [modalApproveVisible, setModalApproveVisible] =
    React.useState<boolean>(false);
  const [uploadedFileQuantity, setUploadedFileQuantity] =
    React.useState<number>(0);
  const {
    data,
    loading: fetching,
    mutate,
  } = useRequest<UserOrder>(() => checkOrder(), {
    ready: order?.id !== "not_found",
  });
  const [imagesNotApproved, setImagesNotApproved] = useState<boolean>(false);

  const { handleS3Delete, validateUpload, listImagesByOrderId } = useHandleS3({
    data,
  });

  const { loading, run } = useRequest(updateOrderApi, {
    manual: true,
    onSuccess: (value) => {
      if (value) {
        dispatchUser({
          type: "UPDATE",
          order: value,
        });
      }
    },
  });

  const downloadFile = async (item: PositionImage | ImageFile) => {
    try {
      const itemAsPositionImage = item as PositionImage;
      if (!data) return;
      const fetchedFiles = listImagesByOrderId.find(
        (item) =>
          item.key === (itemAsPositionImage.pdfKey ?? itemAsPositionImage.key)
      );
      if (
        fetchedFiles &&
        fetchedFiles.key &&
        fetchedFiles.lastModified &&
        fetchedFiles.size
      ) {
        const fileData = {
          lastModified: fetchedFiles.lastModified.getMilliseconds(),
          name: fetchedFiles.key,
          type: getExtensionFileName(fetchedFiles.key),
          size: fetchedFiles.size,
          webkitRelativePath: "",
        };
        const fileDetails: UploadFileProps = {
          file: fileData as File,
          key: item.key,
          progress: 100,
          uploadStatus: UploadStatus.DONE,
        };
        if (itemAsPositionImage.quantity) {
          fileDetails.positionImage = itemAsPositionImage;
        }
        return fileDetails;
      }
    } catch (error) {
      if (error && (error as Error).message) {
        toast.error((error as Error).message);
      } else {
        toast.error("We are unable to load image details contact admin.");
      }
    }
    return null;
  };

  const fetchingPositionImage = async (
    positionItem?: Position
  ): Promise<UploadFileProps[]> => {
    const downloadPromise =
      positionItem?.positionImage?.map((item) => downloadFile(item)) || [];
    const response = await Promise.all(downloadPromise);
    const allFiles: UploadFileProps[] = [];
    for (const r of response) {
      if (r) {
        allFiles.push(r);
      }
    }
    return allFiles;
  };
  // get uploaded images to display
  const fetchImage = async () => {
    const fetchedFilesData: UploadFileProps[] = [];
    if (!data?.positions) return;
    const completeValidationPosition: TPositionReq[] = [];
    setFurtherInfoFlowingMotifs(data.furtherInfoFlowingMotifs ?? false);
    setFurtherInfoQualityCheck(data.furtherInfoQualityCheck ?? false);
    let totalQuantitySum: number = 0;
    for (let index in data.positions) {
      if (data.positions[index].White == false) {
        totalQuantitySum = totalQuantitySum + data.positions[index].quantity;
      }
      // Get which position is validated
      if (data.positions[index].positionImage?.length) {
        const possiblePositions: TPositionReq[] = [];
        for (let positionImage of data.positions[index].positionImage || []) {
          data.positions.map((m, ind) => {
            if (
              positionImage.filledPositionArticleNumber?.includes(
                m.articleNumber
              )
            ) {
              if (
                possiblePositions.find((f) => Number(ind) === f.position) &&
                possiblePositions[Number(ind)] &&
                possiblePositions[Number(ind)].quantity
              ) {
                possiblePositions[Number(ind)].quantity =
                  possiblePositions[Number(ind)].quantity +
                  positionImage.quantity;
              } else {
                possiblePositions.push({
                  position: Number(ind),
                  quantity: positionImage.quantity,
                  atLeastFilledByOneFile: true,
                });
              }
            }
          });
        }
        completeValidationPosition.push(...possiblePositions);
      }
      // Fetching Position Image details
      const file = await fetchingPositionImage(data.positions[index]);
      fetchedFilesData.push(...file);
    }
    let counter: number = 0;
    for (let index in [...fetchedFilesData]) {
      let n: any = [...fetchedFilesData][index].positionImage?.quantity;
      counter = counter + n;
    }
    //set total number of already uploaded files
    await setUploadedFileQuantity(counter);
    // set total number of quantity person can upload
    setTotalQuantity(totalQuantitySum);
    // set fetched image validation quantity
    setPositionRequirement(removeDuplicates([...completeValidationPosition]));
    setUploadFiles([...fetchedFilesData]);
    completedImages.current = [...fetchedFilesData];
  };

  useEffect(() => {
    const uploadingImages = uploadFiles.filter((f) => {
      return f.uploadStatus !== UploadStatus.DONE;
    });
    const uploadingFiles = files.filter(
      (f) => f.uploadStatus !== UploadStatus.DONE
    );
    if (uploadingImages.length > 0 || uploadingFiles.length > 0) {
      setUploading(true);
    } else {
      setUploading(false);
    }
  }, [uploadFiles, files]);

  React.useEffect(() => {
    if (!order) return;
    handleOrderUpdate({ id: order.id, lastOpened: order.email });
  }, [order]);

  React.useEffect(() => {
    if (!data || (data && !data.positions)) return;
    setUploadFiles([]);
    fetchImage();
  }, [listImagesByOrderId, data]);
  const history = useHistory();
  const sendPrintData = async () => {
    //if(!data) return;
    if (data?.positions.some(({ positionImage }) => positionImage?.length)) {
      const imageStatus: any = data?.positions.some(({ positionImage }) =>
        positionImage?.some(
          ({ approvalStatus }) => approvalStatus === ApprovalStatus.No
        )
      );
      setImagesNotApproved(imageStatus);
      if (imageStatus) {
        scrollToNotApprovedImage();
        toast.error(t("checkUploadedImages"));
        return;
      }
    }

    if (totalQuantity < uploadedFileQuantity) {
      setShowQuantityModal(true);
    } else if (totalQuantity > uploadedFileQuantity) {
      setShowQuantityModal(true);
    } else {
      if (!data) return;
      // check positions are validated.
      // for (let i = 0; i < data.positions.length; i++) {
      //   if (
      //     data.positions[i].productGroup &&
      //     data.positions[i].positionImage?.find(
      //       (image) => image.approvalStatus === ApprovalStatus.No
      //     )
      //   )
      //    {
      //     toast.error(t("positionsNotCompleted"));
      //     return;
      //   }
      //   const value = positionRequirement.find(
      //     (item) => item.position === i && item.atLeastFilledByOneFile
      //   );
      //   if (!value) {
      //     toast.error(t("positionsNotCompleted"));
      //     return;
      //   }
      // }

      await run({
        id: data.id,
        status:
          data.status === StatusConst.Error ||
          data.status === StatusConst.ReUploaded
            ? StatusConst.ReUploaded
            : StatusConst.Uploaded,
        furtherInfoFlowingMotifs,
        furtherInfoQualityCheck,
        uploadedDate: new Date().toISOString(),
        ...(furtherInfo
          ? furtherInfo === order?.furtherInfo
            ? {}
            : { furtherInfo }
          : { furtherInfo: "" }),
      });
      setTimeout(() => {
        setSent(true);
        logout(); // Log out the user
        dispatchUser({ type: "SIGN_OUT" });
        history.push("/sended");
      }, 300);
    }
  };
  const sendPrintDataAnyway = async () => {
    if (!data) return;

    await run({
      id: data.id,
      status:
        data.status === StatusConst.Error ||
        data.status === StatusConst.ReUploaded
          ? StatusConst.ReUploaded
          : StatusConst.Uploaded,
      furtherInfoFlowingMotifs,
      furtherInfoQualityCheck,
      uploadedDate: new Date().toISOString(),
      ...(furtherInfo
        ? furtherInfo === order?.furtherInfo
          ? {}
          : { furtherInfo }
        : { furtherInfo: "" }),
    });
    setTimeout(() => {
      setSent(true);
      logout(); // Log out the user
      dispatchUser({ type: "SIGN_OUT" });
      history.push("/sended");
    }, 300);
  };
  // fetch file which is attached by customer.
  const fetchingPositionFile = async (item: ImageFile) => {
    try {
      if (!data) return;
      const fetchedFiles = listImagesByOrderId.find(
        (val) => val.key === item.key
      );
      if (
        fetchedFiles &&
        fetchedFiles.key &&
        fetchedFiles.lastModified &&
        fetchedFiles.size
      ) {
        const fileData = {
          lastModified: fetchedFiles.lastModified.getMilliseconds(),
          name: item.name,
          type: getExtensionFileName(fetchedFiles.key),
          size: fetchedFiles.size ?? 0,
          webkitRelativePath: "",
        };
        const fileDetails: UploadFileProps = {
          file: fileData as File,
          key: item.key,
          progress: 100,
          uploadStatus: UploadStatus.DONE,
        };
        return fileDetails;
      }
    } catch (error) {
      if (error && (error as Error).message) {
        toast.error((error as Error).message);
      } else {
        toast.error("We are unable to load file details contact admin.");
      }
    }
    return null;
  };

  // get uploaded notes to display
  const fetchFiles = async () => {
    setDeliveryNoteLoading(true);
    if (!data) return;
    const downloadPromise = data.files.map((item) =>
      fetchingPositionFile(item)
    );

    const response = await Promise.all(downloadPromise);
    const allFiles: UploadFileProps[] = [];
    for (const r of response) {
      if (r) {
        allFiles.push(r);
      }
    }
    setFiles([...allFiles]);
    completedNotes.current = [...allFiles];
    setDeliveryNoteLoading(false);
  };

  /**
   * This is used to remove single position image file from db and s3
   * @param index index of image which will be removed
   * @param item single position image details
   */
  const handleRemoveSingleFile = async (
    index: number,
    item: UploadFileProps
  ) => {
    try {
      if (!data) return;
      setCardLoading(true);
      const updatedImages = uploadFiles.filter((_, idx) => idx !== index);
      let removeFile: PositionImage | undefined;
      setUploadFiles(updatedImages);
      const positions = data.positions.map((position, index) => {
        const positionImage = position.positionImage?.filter((img) => {
          if (img.key === item.file.name) {
            removeFile = img;
            return false;
          }
          return true;
        });
        return { ...data.positions[index], positionImage };
      });
      data.positions = positions;
      const _order = await handleOrderUpdate({
        id: data.id,
        positions: data.positions,
      });
      toast.success(t("positionImageRemoved"));
      if (removeFile) {
        await Promise.all(handleS3Delete(removeFile));
      }
      completedImages.current = [
        ...completedImages.current.filter((f) => f.key !== item.key),
      ];
      if (_order) mutate(_order);
    } catch (error) {
      if (error && (error as Error).message) {
        toast.error((error as Error).message);
      } else {
        toast.error("We are unable to remove delivery image.");
      }
    } finally {
      setUploading(false);
      setCardLoading(false);
    }
  };

  const handleRemoveFile = async (index: number, item: Position) => {
    try {
      if (item.positionImage?.length === 0 || !data) return;
      data.positions[index] = { ...item, positionImage: [] };
      await handleOrderUpdate({
        id: data.id,
        positions: data.positions,
        files: [],
      });
      const removePromisesArray =
        item.positionImage?.map((item) => {
          return handleS3Delete(item);
        }) || [];
      await Promise.all(removePromisesArray);
      const removeDeliveryNotes = data.files.map((item) => {
        return Storage.remove(item.key);
      });
      await Promise.all(removeDeliveryNotes);
    } catch (error) {
      if (error && (error as Error).message) {
        toast.error((error as Error).message);
      } else {
        toast.error("We are unable to process this request.");
      }
    }
  };

  // This method is used to remove uploaded notes
  const handleRemoveNote = async (index: number, item: UploadFileProps) => {
    try {
      setCardLoading(true);
      if (!data) return;
      const updatedNotes = files.filter((_, idx) => idx !== index);
      let removeFile: ImageFile | undefined;
      setFiles(updatedNotes);
      const filteredFile = data.files.filter((note) => {
        if (note.key === item.key) {
          removeFile = note;
          return false;
        }
        return true;
      });
      data.files = filteredFile;
      const _order = await handleOrderUpdate({
        id: data.id,
        files: data.files,
      });
      toast.success(t("positionImageRemoved"));
      if (removeFile) {
        await Storage.remove(removeFile.key);
      }
      completedNotes.current = [
        ...completedNotes.current.filter((f) => f.key !== item.key),
      ];
      if (_order) mutate(_order);
    } catch (error) {
      if (error && (error as Error).message) {
        toast.error((error as Error).message);
      } else {
        toast.error("We are unable to remove delivery notes.");
      }
    } finally {
      setUploading(false);
      setCardLoading(false);
    }
  };

  // This method is used to bulk upload notes
  const handleUploadNotes = async (selectedFiles: File[]) => {
    const newFiles: UploadFileProps[] = [];
    if (!data) return;

    const allowedExtensions = [
      "pdf",
      "csv",
      "xls",
      "xlsx",
      "xlsm",
      "xlsb",
      "xlt",
      "xla",
    ];

    for (let file of selectedFiles) {
      if (!file || !file.name) {
        console.warn("File or filename is undefined or null");
        continue;
      }

      const fileExtension = file.name.split(".").pop()?.toLowerCase();

      if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
        toast.warn(
          t("allowedFormats", { name: file.name, formats: "PDF, CSV, Excel" })
        );
        continue;
      }

      const sanitizedFileName = getCleanFileName(file.name);

      newFiles.push({
        file,
        key: `${data.id}/${Date.now()}-${sanitizedFileName}`,
        uploadStatus: UploadStatus.NOT_STARTED,
      });
    }

    setFiles([...files, ...newFiles]);
  };

  React.useEffect(() => {
    if (!data || (data && !data.files)) return;
    setFiles([]);
    fetchFiles();
  }, [listImagesByOrderId, data]);

  // remove duplicates from position requirement
  const removeDuplicates = (arr: TPositionReq[]) => {
    const uniqueIds: number[] = [];
    return arr.filter((element) => {
      const isDuplicate = uniqueIds.includes(element.position);

      if (!isDuplicate) {
        uniqueIds.push(element.position);
        return true;
      }
      return false;
    });
  };

  const handleFileSelections = async (files: File[]) => {
    if (files.length > 0) {
      const newUploadedFiles: UploadFileProps[] = [];
      // for each file validate
      let updatedPositionRequirement: TPositionReq[] = [];
      for (let file of files) {
        if (!/png|jpeg|jpg|pdf|epub/.test(file.type)) {
          toast.warn(t("unsupportedFileWithName", { name: file.name }));
          continue;
        }

        // check position image quantity
        let sum = uploadFiles.reduce((acc: number, curr: UploadFileProps) => {
          if (curr.positionImage) {
            return acc + curr.positionImage.quantity;
          }
          return acc;
        }, 0);
        sum = updatedPositionRequirement.reduce(
          (acc: number, curr: TPositionReq) => acc + (curr.quantity ?? 0),
          0
        ) + sum;
        // validate quantity should be less than total quantity
        // if (sum >= totalQuantity) {
        //   toast.error(t("positionsCompleted"));
        //   break;
        // }

        // validate image or pdf
        const response = await validateUpload({ file });
        if (response) {
          updatedPositionRequirement = response.filledPositions.map(
            (position) => {
              return {
                position,
                quantity: response.positionImage.quantity,
                atLeastFilledByOneFile: true,
              };
            }
          );

          sum = response.positionImage.quantity + sum;
          // validate quantity should be less than total quantity

          // if (sum > totalQuantity) {
          //   toast.error(t("positionsCompleted"));
          //   break;
          // }
          newUploadedFiles.push({
            file,
            uploadStatus: UploadStatus.NOT_STARTED,
            ...response,
          });
        }

        setPositionRequirement(
          removeDuplicates([
            ...positionRequirement,
            ...updatedPositionRequirement,
          ])
        );
      }

      setUploadFiles([
        ...newUploadedFiles,
        ...uploadFiles.map((i) => {
          return {
            ...i,
            progress: 100,
            uploadStatus:
              i.uploadStatus !== UploadStatus.DONE
                ? UploadStatus.UPLOADING
                : UploadStatus.DONE,
          };
        }),
      ]);
    }
  };

  /**
   * This method is used to Update uploaded Images in Database
   */
  const handleFileUploadComplete = async () => {
    try {
      if (!data || completedImages.current.length < uploadFiles.length) return;
      setCardLoading(true);
      const updated = completedImages.current
        .map((image) => image.positionImage)
        .filter((f) => f);
      const positionImage: PositionImage[] = [...(updated as PositionImage[])];
      const position = { ...data.positions[0], positionImage };
      data.positions[0] = position;
      const updateOrder = await handleOrderUpdate({
        id: data.id,
        positions: data.positions,
      });
      if (!updateOrder) return;
      dataToBeUpdated.current = updateOrder;
      const mutateNow = completedImages.current.find(
        (f) => f.uploadStatus === UploadStatus.DONE && f.file && isPDF(f.file)
      );
      if (!mutateNow) {
        mutate(updateOrder);
      }
    } catch (error) {
      if (error && (error as Error).message) {
        toast.error((error as Error).message);
      } else {
        toast.error("We are unable to upload image.");
      }
    } finally {
      setCardLoading(false);
      setUploading(false);
    }
  };

  /**
   * This method is used to upload delivery notes
   * @param item delivery note
   * @param response having key of delivery note that is uploaded in s3
   */
  const handleNotesUploadComplete = async () => {
    try {
      setCardLoading(true);
      if (!data || completedNotes.current.length !== files.length) return;
      const currentUpdatedFile = completedNotes.current
        .map((file) => {
          return { key: file.key, name: file.file.name };
        })
        .filter((f) => f);
      if (!data) return;

      const _order = await handleOrderUpdate({
        id: data.id,
        files: [...currentUpdatedFile],
      });
      if (_order) mutate(_order);
      setFiles([...completedNotes.current]);
    } catch (error) {
      if (error && (error as Error).message) {
        toast.error((error as Error).message);
      } else {
        toast.error("We are unable to upload delivery notes.");
      }
    } finally {
      setUploading(false);
      setCardLoading(false);
    }
  };
  const handleConfirm = async () => {
    setShowQuantityModal(false);
    sendPrintDataAnyway();
  };
  const handleCancel = async () => {
    setShowQuantityModal(false);
  };
  const onModalApproveClose = () => {
    setModalApproveVisible(false);
    setCurrent(null);
  };

  const grantReleaseCallback = (_order: UserOrder) => {
    setImagesNotApproved(false);
    mutate(_order);
    onModalApproveClose();
  };

  const handleComment = async (item: UploadFileProps) => {
    if (!data) return;
    data.positions[0].positionImage =
      data.positions[0].positionImage?.map((m) => {
        if (m.key === item.positionImage?.key) {
          return item.positionImage;
        }
        return m;
      }) || [];
    const _order = await handleOrderUpdate({
      id: data.id,
      positions: data.positions,
    });
    if (_order) mutate(_order);
  };

  const handleOrderUploadRefresh = (
    order: Partial<UserOrder> & { id: string }
  ) => {
    if (order.id !== data?.id || order.notificationAt === data?.notificationAt)
      return;
    dataToBeUpdated.current && mutate(dataToBeUpdated.current);
    setUploadFiles([...completedImages.current]);
  };

  useEffect(() => {
    if (
      !updatedOrder ||
      (updatedOrder &&
        !(updatedOrder as Record<"onUpdateOrderItem", UserOrder>)
          .onUpdateOrderItem)
    )
      return;

    handleOrderUploadRefresh(
      (updatedOrder as Record<"onUpdateOrderItem", UserOrder>).onUpdateOrderItem
    );
  }, [updatedOrder]);

  const scrollToNotApprovedImage = () => {
    const notApprovedEl = document.querySelector("[data-approved=false]");
    if (!notApprovedEl) return;
    let pos =
      notApprovedEl.getBoundingClientRect().top -
      document.body.getBoundingClientRect().top -
      250;
    setImmediate(() =>
      window.scroll({
        top: pos,
        behavior: "smooth",
      })
    );
  };

  return (
    <AccountLayout account>
      <LoaderOverlay visible={cardLoading || fetching || deliveryNoteLoading} />
      {order.chooseUpload && !positionImageAvailable() && (
        <DangerModal
          handleDelete={() =>
            data?.positions.forEach((item, index) =>
              handleRemoveFile(index, item)
            )
          }
        />
      )}
      {!sent ? (
        <>
          {!fetching && data && data.id !== "not_found" ? (
            <>
              <p className="section-title">
                {t("order")} {data.id}
              </p>
              <div className="flex flex-col md:flex-row gap-10 mb-20 mt-4">
                <div className="flex-1 flex">
                <OrderAddressCard
                  data={data}
                  isShippingAddressEditable={false}
                  onUpdateOrder={(order) => mutate(order)}
                />
                </div>
                <div className="flex-1 flex">
                <div className="card-auto pb-8 px-8 pt-2 grid print-data-upload upload-instruction">
                  <p className="text-sm font-bold">{t("instructions")}</p>
                  <p className="text-sm"> {t("instructionContent")}</p>
                  <p className="text-sm">
                    <strong> {t("serviceTime")}:</strong> {t("uploadTime")}
                  </p>
                </div>
                </div>
              </div>

              <div className="print-data-upload grid gap-45 pt-50 ">
                <div>
                  <p
                    className={`section-heading mb-16 ${
                      !isEditableCustomerView(data.status) && "opacity-disabled"
                    }`}
                  >
                    {t("printDataUpload")}
                  </p>
                  {(data.status === StatusConst.Uploaded ||
                    data.status === StatusConst.ReUploaded) && (
                    <div className="card-auto p-16 py-40 mb-16">
                      <div className="row row-center text-center py-40">
                        <h4>{t("orderInReviewMessage")}</h4>
                      </div>
                    </div>
                  )}
                  {data.status === StatusConst.Production && (
                    <div className="card-auto p-16 py-40 mb-16">
                      <div className="row row-center text-center py-40">
                        <h4>{t("orderInProduction")}</h4>
                      </div>
                    </div>
                  )}
                  <div
                    className={`${
                      !isEditableCustomerView(data.status) &&
                      "opacity-disabled pointer-events-none"
                    }`}
                  >
                    <AddImageCard
                      onSelectedFiles={(files: File[]) =>
                        handleFileSelections(files)
                      }
                      disabled={!isEditableCustomerView(data.status)}
                    />
                    {/* Upload order data   progress card  */}
                    {uploadFiles.map((item, index) => {
                      return (
                        <div key={item.key}>
                          <CustomerOrderDataCard
                            order={order}
                            key={item.key}
                            onRemove={() => handleRemoveSingleFile(index, item)}
                            item={item}
                            showField={true}
                            onComplete={() => {
                              completedImages.current.push({
                                ...item,
                                uploadStatus: UploadStatus.DONE,
                              });
                              handleFileUploadComplete();
                            }}
                            onHandleComment={(comment) =>
                              handleComment(comment)
                            }
                            setCurrent={(curr) => setCurrent(curr)}
                            setModalApproveVisible={(val) =>
                              setModalApproveVisible(val)
                            }
                            disabled={!isEditableCustomerView(data.status)}
                            showGalleryPreview={true}
                          />
                        </div>
                      );
                    })}

                    <div className="row row-v-center gap-4">
                      <p className="section-heading mt-70">
                        {t("furtherInformation")}
                      </p>
                      <p className="mt-70">({t("optional")})</p>
                    </div>
                    <div className="card-auto pb-40 p-16">
                      <Checkbox
                        disabled={!isEditableCustomerView(data.status)}
                        radius={5}
                        label={t("furtherInfoFlowingMotifs")}
                        className="checkbox-border mb-10 mx-25"
                        checked={furtherInfoFlowingMotifs}
                        onChange={(e: any) =>
                          setFurtherInfoFlowingMotifs(e.target.checked)
                        }
                      />

                      <Checkbox
                        disabled={!isEditableCustomerView(data.status)}
                        radius={5}
                        label={t("furtherInfoQualityCheck")}
                        className="checkbox-border mb-20 mx-25"
                        checked={furtherInfoQualityCheck}
                        onChange={(e: any) =>
                          setFurtherInfoQualityCheck(e.target.checked)
                        }
                      />
                      <div className="w-sx">
                        <Textarea
                          disabled={!isEditableCustomerView(data.status)}
                          className="mt-10 mx-25"
                          minRows={4}
                          defaultValue={order?.furtherInfo}
                          onChange={(e) => setFurtherInfo(e.target.value)}
                        ></Textarea>
                      </div>
                    </div>
                    <div className="row row-v-center gap-4">
                      <p className="section-heading mt-50 mb-16">
                        {t("uploadOwnDeliveryNote")}
                      </p>
                      <p className="mt-50 mb-16">({t("optional")})</p>
                    </div>
                    {!deliveryNoteLoading && (
                      <AddImageCard
                        onSelectedFiles={(newFile: File[]) => {
                          handleUploadNotes(newFile);
                        }}
                        disabled={!isEditableCustomerView(data.status)}
                      />
                    )}
                    {files.map((item, index) => {
                      return (
                        <CustomerOrderDataCard
                          order={order}
                          onRemove={() => handleRemoveNote(index, item)}
                          showField={false}
                          item={item}
                          onComplete={() => {
                            completedNotes.current.push({
                              ...item,
                              uploadStatus: UploadStatus.DONE,
                            });
                            handleNotesUploadComplete();
                          }}
                          disabled={!isEditableCustomerView(data.status)}
                        />
                      );
                    })}
                    <h4 className="section-heading mt-50 mb-16">
                      {t("sendPrintdatah4")}
                    </h4>
                    <div
                      style={{
                        border: imagesNotApproved ? "3px solid crimson" : "",
                      }}
                      className="card-auto py-40 mb-16 p-16 mt-20 row row-column row-center row-v-center"
                    >
                      {/* <div className="send-printdata mt-50"> */}

                      <Checkbox
                        disabled={!isEditableCustomerView(data.status)}
                        radius={5}
                        label={t("approveText")}
                        className="checkbox-border "
                        checked={approved}
                        onChange={(e: any) => setApproved(e.target.checked)}
                      />
                      <Button
                        className="sendprintdata"
                        size="lg"
                        mt={10}
                        loading={loading}
                        disabled={
                          !approved ||
                          loading ||
                          uploading ||
                          deliveryNoteLoading ||
                          !isEditableCustomerView(data.status) ||
                          imagesNotApproved
                        }
                        onClick={() => sendPrintData()}
                      >
                        {t("sendPrintdata")}
                      </Button>
                      {/* </div> */}
                    </div>
                  </div>
                </div>
                <div
                  style={{ borderLeft: "1px solid #000", paddingLeft: "45px" }}
                  className="pr-16-tab-responsive"
                >
                  <UploadInstructions positions={order.positions} />
                </div>
              </div>
              <Modal
                compact
                center
                visible={modalApproveVisible}
                onClose={onModalApproveClose}
              >
                {current && (
                  <>
                    {current.approvalStatus === ApprovalStatus.Yes && (
                      <RenderApproveView current={current} />
                    )}
                    {current.approvalStatus === ApprovalStatus.No && (
                      <RenderDontApproveView
                        current={current}
                        order={data}
                        item={data.positions[0]}
                        callback={grantReleaseCallback}
                      />
                    )}
                  </>
                )}
              </Modal>
            </>
          ) : (
            <div className="row row-center mt-30">
              <Loader />
            </div>
          )}
        </>
      ) : (
        <div className="sent-printdata">
          <CheckGreenIcon />
          <span>{t("sendSuccess")}</span>
          <p className="p-4">{t("thankYouForUploading")}</p>
          <FaEnvelope
            style={{
              paddingTop: "48px",
              width: "34px",
              height: "34px",
              flexShrink: 0,
            }}
          />
          <p style={{ paddingBottom: "64px" }} className="p-2">
            {t("recieveUpdates")}
          </p>
          <div
            style={{
              width: "100%",
              maxWidth: "457px",
              flexShrink: 0,
              borderRadius: "25px",
              background: "#FFF",
              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.5)",
            }}
          >
            <p style={{ marginTop: "39px", fontWeight: 500, fontSize: "24px" }}>
              {t("happensNext")}
            </p>
            <FaEye
              style={{
                paddingTop: "48px",
                width: "34px",
                height: "34px",
                flexShrink: 0,
              }}
            />
            <p style={{ fontSize: "12px" }}>{t("happensNextStep1")}</p>
            <FaEnvelope
              style={{
                paddingTop: "48px",
                width: "34px",
                height: "34px",
                flexShrink: 0,
              }}
            />
            <p style={{ fontSize: "12px" }}>{t("happensNextStep2")}</p>
            <FaPaperPlane
              style={{
                paddingTop: "48px",
                width: "34px",
                height: "34px",
                flexShrink: 0,
              }}
            />
            <p style={{ fontSize: "12px" }}>{t("happensNextStep3")}</p>
            <FaIndustry
              style={{
                paddingTop: "48px",
                width: "34px",
                height: "34px",
                flexShrink: 0,
              }}
            />
            <p style={{ fontSize: "12px", paddingBottom: "48px" }}>
              {t("happensNextStep4")}
            </p>
          </div>
        </div>
      )}
      <QuantityModal
        modalVisible={ShowQuantityModal}
        setModalVisible={setShowQuantityModal}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        uploadedQuantity={uploadedFileQuantity}
        orderedQuantity={totalQuantity}
      />
    </AccountLayout>
  );
};

export default AccountBulkUpload;
